import DevicePayments from './DevicePayments';

export default DevicePayments;
